import React from "react";
import { ArrowRight, ImageIcon } from "lucide-react";
import { useAccentColor } from "utils/accent-color";
import { formatEyebrowNumber } from "./knowledge-filters";

// Surfaces the next unread article (pinned first) so a returning reader can
// pick up without hunting through chapters.
const UpNextCard = ({ article, onOpen }) => {
  const accent = useAccentColor(article.chapter?.color_code);
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-4 rounded-lg border border-border bg-surface p-3 sm:p-4">
      <div className="flex items-center gap-4 min-w-0 flex-1">
        <div className="flex-shrink-0 w-20 h-14 sm:w-28 sm:h-[72px] rounded-md overflow-hidden bg-surface_alt border border-border flex items-center justify-center">
          {article.banner_image ? (
            <img src={article.banner_image} alt="" className="w-full h-full object-cover" />
          ) : (
            <ImageIcon size={18} className="text-text_muted" />
          )}
        </div>
        <div className="min-w-0">
          <p className="font-mono text-[10px] uppercase tracking-[0.18em]" style={{ color: accent.text }}>
            Up next · Chapter {formatEyebrowNumber(article.chapterNumber)}
          </p>
          <h3 className="mt-1 text-[15px] sm:text-base font-bold text-text_primary leading-snug line-clamp-2">
            {article.title}
          </h3>
        </div>
      </div>
      <button
        type="button"
        onClick={() => onOpen(article.id)}
        className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-md bg-primary text-white text-[13px] font-semibold cursor-pointer"
      >
        Start reading <ArrowRight size={15} />
      </button>
    </div>
  );
};

export default UpNextCard;
